import React from 'react';

const Breadcrumbs = (props)=> {
	const items = [];
	for (let i = 0; i < props.Steps; i++) {
	  items.push(<li className={(props.Step === i+1)? "active" : ""} key={i}></li>)
	}
  return (
	<div className="breadcrumbs">
		<ol className="dots">
			{items}
		</ol>
		<div className="steps">{props.Step}/{props.Steps}</div>
	</div>
  );
}

export default Breadcrumbs;
